import * as dashboardConfigApi from "@hub/dashboard/src/api/dashboard-config.api"
import createErrorMessage from "@shared/factories/src/errorMessage.factory"

const normalizeFilter = ({ default_value: defaultValue, ...filter }) => {
  if (defaultValue === null || defaultValue === undefined) {
    return filter
  }

  return { ...filter, defaultValue }
}

const normalizeTab = ({ quick_filters: quickFilters, ...tab }) => ({
  ...tab,
  quickFilters: (quickFilters || []).map(normalizeFilter),
  charts: tab.charts || []
})

const normalizeDashboardConfig = data => ({
  ...data,
  filters: (data.filters || []).map(normalizeFilter),
  tabs: (data.tabs || []).map(normalizeTab)
})

export const fetchDashboardConfig = async () => {
  try {
    const { data } = await dashboardConfigApi.fetchCurrentDashboard()

    return data ? normalizeDashboardConfig(data) : null
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title: createErrorMessage(error).getMessage() || "Falha ao obter dashboard."
    })

    return null
  }
}
